import { useEffect, useReducer } from "react";
import { ApprovalFlowReducer, initialState } from "./approvalPool.reducer";
import { useAuth } from "../../../../../contexts/AuthContext";
import {
  createPools,
  deletePools,
  getPoolDetails,
  getPools,
  updatePools,
} from "../api/ApprovalFlow.api";
import {
  setError,
  setLoading,
  setPools,
  setToast,
  setUsersManagement,
} from "./appprovalPool.action";
import apiService from "../../../../../services/api";
import { PoolModelData } from "../model/approvalPoolModel";

export const useApprovalViewModel = () => {
  const [state, dispatch] = useReducer(ApprovalFlowReducer, initialState);
  const { user: currentUser } = useAuth();
  const showToastMessage = (
    message: string,
    type: "success" | "error" | "warning" | "info",
  ) => dispatch(setToast({ isVisible: true, message, type }));
  useEffect(() => {
    fetchPools();
    loadUsers();
  }, []);
  const loadUsers = async () => {
    try {
      if (currentUser?.company_id) {
        const data = await apiService.getCompanyUsers(currentUser.company_id, {
          status_filter: "all",
        });
        dispatch(setUsersManagement(data));
        console.log("data pass", data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPools = async (params: any = {}) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));
      const resp = await getPools();
      dispatch(setPools(resp.data));
      console.log(resp);
      // dispatch(setTotal(resp.data.total));
    } catch (err) {
      console.log(err);
      dispatch(setError("Failed to fetch Pools"));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const updatePoolsData = async (id: any, payload: any) => {
    try {
      const resp = await updatePools(id, payload);
      console.log(resp);
      showToastMessage("Pool update successfully", "success");
      await fetchPools();

      dispatch({ type: "CLOSE_DELETE_DIALOG" });
      return { success: true };
    } catch (error) {
      console.log(error);
      showToastMessage("Failed to update pool", "error");
      return { success: false, error };
    }
  };

  const handleCreatePool = async () => {
    dispatch(setLoading(true));
    try {
      if (state.editingPool) {
        const updatePayload = {
          name: state.poolFormData.name,
          description: state.poolFormData.description,
          member_ids: state.poolFormData.members ?? [],
          is_active: true,
        };

        const updateResult = await updatePoolsData(state.editingPool.id, updatePayload);

        if (!updateResult.success) {
          throw updateResult.error || new Error("Failed to update pool");
        }

        dispatch(
          setToast({
            isVisible: true,
            type: "success",
            message: "Pool updated successfully",
          }),
        );
      } else {
        const payload = {
          name: state.poolFormData.name,
          description: state.poolFormData.description,
          member_ids: Array.isArray(state.poolFormData.members)
            ? state.poolFormData.members
            : [],
        };

        await createPools(payload);

        dispatch(
          setToast({
            isVisible: true,
            type: "success",
            message: "Pool created successfully",
          }),
        );
      }

      dispatch({ type: "CLOSE_POOL_DIALOG" });
    } catch (err: any) {
      console.error("Pool operation failed", err);
      const errorMessage =
        err?.response?.data?.message ||
        (state.editingPool ? "Failed to update pool" : "Failed to create pool");
      dispatch(
        setToast({
          isVisible: true,
          type: "error",
          message: errorMessage,
        }),
      );
    } finally {
      dispatch({
        type: "SET_POOL_FORM_DATA",
        payload: { name: "", description: "", members: [] },
      });
      dispatch({ type: "CLOSE_POOL_DIALOG" });
      await fetchPools();
      dispatch(setLoading(false));
    }
  };

  const deletePoolData = async () => {
    const id = state.deletingFlowId;
    if (!id) return;
    try {
      dispatch(setLoading(true));
      const resp = await deletePools(id);
      console.log(resp);
      showToastMessage("Pool deleted successfully", "success");
      dispatch({ type: "CLOSE_DELETE_DIALOG" });
      await fetchPools();
    } catch (error) {
      console.log(error);
      showToastMessage(
        "Cannot delete pool: it is used in an approval flow. Remove it from all flows first.",
        "error",
      );
      dispatch({ type: "CLOSE_DELETE_DIALOG" });
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleEditPool = async (pool: PoolModelData) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });

      const resp = await getPoolDetails(pool.id);

      dispatch({
        type: "SET_EDITING_POOL",
        payload: resp.data,
      });

      dispatch({ type: "SET_POOL_DIALOG_OPEN", payload: true });
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  // const handleEditPool = async (pool: PoolModelData) => {
  //   try {
  //     dispatch({ type: "SET_LOADING", payload: true });

  //     const resp = await getPoolDetails(pool.id);

  //     dispatch({
  //       type: "SET_EDITING_POOL",
  //       payload: resp.data, // full pool detail
  //     });

  //     dispatch({ type: "SET_POOL_DIALOG_OPEN", payload: true });
  //   } catch (err) {
  //     // dispatch({
  //     //   type: "SHOW_TOAST",
  //     //   payload: {
  //     //     type: "error",
  //     //     message: "Failed to load pool details",
  //     //   },
  //     // });
  //   } finally {
  //     dispatch({ type: "SET_LOADING", payload: false });
  //   }
  // };

  return {
    state,
    dispatch,
    fetchPools,
    loadUsers,
    handleCreatePool,
    deletePoolData,
    updatePoolsData,
    handleEditPool,
  };
};
